import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withPropsOnChange from 'recompose/withPropsOnChange';
import MAP from './gMap/GMap';

export const MapReport = ({
  title, width = 'auto', height = 'auto', markers, mapContainerStyles
}) => (
  <div className="report"
    style={{
      height,
      width,
    }}
  >
    <h2>{t(title)}</h2>
    <MAP style={mapContainerStyles}
      markers={markers}
    />
  </div>
);

export const MapReportHOC = compose(defaultProps({
  mapContainerStyles: {
    height: '91%',
    margin: '7px 0 0 0'
  }
}),
withPropsOnChange(
  ['markers'],
  ({ markers }) => ({
    markers: ! markers || ! markers.length ? [{
      lat: 36.778259,
      lng: -119.417931,
    }] : markers
  }),
));

export default connect()(MapReportHOC(MapReport));
